var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34432 4.66652C6.3441 5.10855 6.16829 5.53239 5.85558 5.84479C5.54286 6.1572 5.11885 6.33258 4.67682 6.33236C4.23479 6.33214 3.81096 6.15633 3.49855 5.84361C3.18615 5.5309 3.01077 5.10688 3.01099 4.66486C3.01121 4.22283 3.18701 3.79899 3.49973 3.48659C3.81245 3.17419 4.23646 2.9988 4.67849 2.99902C5.12051 2.99924 5.54435 3.17505 5.85675 3.48777C6.16916 3.80049 6.34454 4.2245 6.34432 4.66652ZM6.39432 7.56652H3.06099V17.9999H6.39432V7.56652ZM11.661 7.56652H8.34432V17.9999H11.6277V12.5249C11.6277 9.47486 15.6027 9.19152 15.6027 12.5249V17.9999H18.8943V11.3915C18.8943 6.24986 13.011 6.44152 11.6277 8.96652L11.661 7.56652Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.2c9fc6d4015c59d5d8a42bc510294fda.svg";
export { ForwardRef as ReactComponent };